import React, { FC } from 'react';
import {
  Box,
  Typography,

} from '@mui/material';
import StyledBox from 'views/rebranded-module/tours-module/ToursListingViewV2/components/HeaderSection/HeaderSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { Typography700 } from 'views/common/components';
import useLayoutHeights from 'views/rebranded-module/common/hooks/UseLayoutHeight';

const HeaderSection: FC<any> = ({ title }) => {
  const cmsData = useContent('ToursListingPage');
  const { LAYOUT_HEIGHT, LAYOUT_HEIGHT_SM } = useLayoutHeights();
  return (
    <StyledBox layoutHeightSM={LAYOUT_HEIGHT_SM} layoutHeightLG={LAYOUT_HEIGHT}>
      <Typography700 component="h1" variant="h3">
        {title}
      </Typography700>
      <Typography component="p" variant="body2" className="HSDescription showTabletAndDesktop">
        {cmsData.headingDescription}
      </Typography>

    </StyledBox>
  );
};

export { HeaderSection };
